import { motion } from "framer-motion";
import { Sparkles, Clock } from "lucide-react";
import { useEventCountdown } from "@/hooks/useEventCountdown";
import { JULY4_GRADIENT } from "@/data/content";

const scrollTo = (id) =>
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

// Festive "New Drop" ribbon for The 250, with a live countdown that only
// appears while the truck has a stop scheduled for today (Eastern time).
export const DropRibbon = () => {
  const cd = useEventCountdown();

  return (
    <motion.button
      data-testid="hero-july4-ribbon"
      onClick={() => scrollTo("donuts")}
      aria-label="See The 250 — our 4th of July donut drop"
      initial={{ y: -14, opacity: 0 }}
      animate={{ y: 0, opacity: 1, scale: [1, 1.04, 1] }}
      transition={{
        y: { delay: 0.1, duration: 0.5 },
        opacity: { delay: 0.1, duration: 0.5 },
        scale: { delay: 1, duration: 2.4, repeat: Infinity, ease: "easeInOut" },
      }}
      className="mb-4 sm:mb-5 group inline-flex items-center gap-2 rounded-full pl-3.5 pr-3.5 py-1.5 text-xs sm:text-sm font-extrabold uppercase tracking-wide text-white shadow-lg ring-1 ring-white/40 hover:brightness-105 transition-[filter]"
      style={{
        background: JULY4_GRADIENT,
      }}
    >
      <Sparkles className="h-4 w-4 shrink-0" />
      <span>
        <span className="hidden sm:inline">New Drop — </span>The 250
      </span>
      {cd ? (
        <span
          data-testid="hero-july4-timer"
          className="inline-flex items-center gap-1 rounded-full bg-white/25 px-2 py-0.5 text-[0.7rem] sm:text-xs font-bold tabular-nums"
        >
          <Clock className="h-3.5 w-3.5 shrink-0" />
          {cd.phase === "opens"
            ? `Opens in ${cd.clock}`
            : `${cd.clock} left today`}
        </span>
      ) : (
        <span className="hidden sm:inline font-bold normal-case tracking-normal text-white/90">
          · Happy 250th, America!
        </span>
      )}
    </motion.button>
  );
};
